module.exports = __webpack_public_path__ + "static/media/Fish.svg";